'use strict';

const saLocationSearchFormCtrl = [
  '$element',

  function ($element) {
    this.submitForm = function () {
      $element.triggerHandler('submit');
    };
  }
];
const saLocationSearchForm = [
  function () {
    return {
      restrict: 'A',
      priority: 2,
      controller: saLocationSearchFormCtrl
    };
  }
];

export default saLocationSearchForm;



// WEBPACK FOOTER //
// ./app/src/common/location_search/location_search_form.js